import { FC, Fragment } from 'react';
import { Grid, Typography } from 'enova-frontend-components';
import { useTranslation } from 'react-i18next';

import { BuildingDetails } from '../../../../../../types/building';
import { SearchMatchLink } from '../searchMatchListItems/searchMatchLink';
import { ApiRequestError } from '../../../../../../services/api';
import { ErrorBox } from '../../../../../../components/errorBox';

interface AdvancedSearchResultsProps {
  error: ApiRequestError | null;
  searchResults: BuildingDetails[] | undefined;
  refetch: () => Promise<unknown>;
}

export const SearchResults: FC<AdvancedSearchResultsProps> = ({ error, refetch, searchResults }) => {
  const { t } = useTranslation();

  if (error) {
    return (
      <ErrorBox
        titleKey="search.error.title"
        descriptionKey="search.error.description"
        onRetry={async () => await refetch()}
        error={error}
      />
    );
  }

  if (!searchResults) {
    return null;
  }

  if (searchResults.length === 0) {
    return (
      <Grid xs={12} item display="flex">
        <Typography>{t('search.no_result')}</Typography>
      </Grid>
    );
  }

  return (
    <Fragment>
      <Grid item xs={12} display="flex" flexDirection="column">
        <Typography variant="h4" component="h2" gutterBottom>
          {t('buildingSections')}
        </Typography>
      </Grid>

      {searchResults?.map((item) => (
        <Grid container display="flex" item key={JSON.stringify(item)} spacing={2} xs={12}>
          <SearchMatchLink building={item} />
        </Grid>
      ))}
    </Fragment>
  );
};
